import { useCallback, useMemo } from 'react';
import {
	useActiveRightSidebarState,
	useRightSidebarController,
} from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/right-sidebar-controller/index.tsx';
import { JIRA_ROVO_AI_PANEL_ID, JIRA_ROVO_AI_PANEL_WIDTH } from '../common/constants.tsx';

export function useSidebarApiObject() {
	const { openRightSidebar, closeRightSidebar, closeCurrentRightSidebar } =
		useRightSidebarController();
	const { panelId, isCollapsed } = useActiveRightSidebarState() || {};

	const isActive = panelId === JIRA_ROVO_AI_PANEL_ID && !isCollapsed;
	const isOtherPanelActive = panelId !== JIRA_ROVO_AI_PANEL_ID && !isCollapsed;

	const openPanel = useCallback(() => {
		isOtherPanelActive && closeCurrentRightSidebar();
		openRightSidebar(JIRA_ROVO_AI_PANEL_ID, JIRA_ROVO_AI_PANEL_WIDTH);
	}, [closeCurrentRightSidebar, isOtherPanelActive, openRightSidebar]);

	const closePanel = useCallback(() => {
		closeRightSidebar(JIRA_ROVO_AI_PANEL_ID);
	}, [closeRightSidebar]);

	return useMemo(
		() => ({
			isPanelOpen: () => isActive,
			openPanel,
			closePanel,
		}),
		[isActive, openPanel, closePanel],
	);
}
